import React from 'react';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import WrapperSection from '../../components/global/WrapperSection';
import FormAddEditStudentEnrollment from '../../components/studentEnrollments/FormAddEditStudentEnrollment';
import { useParams } from 'react-router-dom';
import { useGetStudentEnrollment } from '../../hooks/studentEnrollments/useGetStudentEnrollment';
import LoadingPage from '../../components/global/LoadingPage';
const EditStudentEnrollment = () => {
    const { id } = useParams();
    const { enrollment, isLoading } = useGetStudentEnrollment(id);
    if (isLoading) return <LoadingPage />;
    return (<WrapperSection><GlobalBreadcrumbs /><FormAddEditStudentEnrollment isEdit currentData={enrollment?.data} /></WrapperSection>);
};
export default EditStudentEnrollment;
